<template>
    <div id="page-404">
        <p id="text-404" class="text-center mt-3">404</p>
        <h1 class="text-center">
            {{ $t("oops") | capitalize-first }}!<br>
            <small>{{ $t("pageNotFound") }}</small>
        </h1>
    </div>
</template>

<script>
export default {
  name: '404',
  data () {
    return {
    }
  },
  created () {
    let theme = this.$store.getters.getTheme
    if (Object.keys(theme).length === 0 && theme.constructor === Object) {
      this.$store.dispatch('setTheme', {
        headerBgColor: '#1a1c28',
        headerFontColor: 'white'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#text-404 {
    font-size: 150px;
    color: lightcoral;
}
</style>
